import { createFileRoute } from '@tanstack/react-router';

import { Box, Flex, Text } from '@chakra-ui/react';

import { adminUserQueries } from '@/features/admin-users/api/adminUserQueries';
import { AdminUserDetail } from '@/features/admin-users/components/AdminUserDetail';

export const Route = createFileRoute('/_authenticated/users/$userId')({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(adminUserQueries.detail(params.userId)),
  component: UserDetailPage,
});

function UserDetailPage() {
  const { userId } = Route.useParams();

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={6}>
        <Text fontSize="2xl" fontWeight="bold">
          管理者ユーザー 詳細
        </Text>
      </Flex>

      <AdminUserDetail userId={userId} />
    </Box>
  );
}
